import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import {
    fetchAdminResumeBuilders,
    addAdminResumeBuilder,
    updateAdminResumeBuilder,
    deleteAdminResumeBuilder,
} from "./AdminResumeBuilderAPI"

const initialState = {
    data: [],
    loading: false,
    error: null,
}

export const fetchAdminResumeBuildersAsync = createAsyncThunk(
    "AdminResumeBuilder/fetch",
    async (_, { rejectWithValue }) => {
        try {
            const data = await fetchAdminResumeBuilders()
            const resp = data.response
            return resp
        } catch (error) {
            return rejectWithValue(error.message)
        }
    },
)

export const addAdminResumeBuilderAsync = createAsyncThunk(
    "AdminResumeBuilder/add",
    async (resumeBuilderData, { rejectWithValue }) => {
        try {
            const data = await addAdminResumeBuilder(resumeBuilderData)
            return data.response
        } catch (error) {
            return rejectWithValue(error.message)
        }
    },
)

export const updateAdminResumeBuilderAsync = createAsyncThunk(
    "AdminResumeBuilder/update",
    async (updateData, { rejectWithValue }) => {
        try {
            const data = await updateAdminResumeBuilder(updateData)
            return data.response
        } catch (error) {
            return rejectWithValue(error.message)
        }
    },
)

export const deleteAdminResumeBuilderAsync = createAsyncThunk(
    "AdminResumeBuilder/delete",
    async (uuid, { rejectWithValue }) => {
        try {
            const data = await deleteAdminResumeBuilder(uuid)
            return { uuid, data: data.response }
        } catch (error) {
            return rejectWithValue(error.message)
        }
    },
)

const AdminResumeBuilderSlice = createSlice({
    name: "AdminResumeBuilder",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch cases
            .addCase(fetchAdminResumeBuildersAsync.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(fetchAdminResumeBuildersAsync.fulfilled, (state, action) => {
                state.loading = false
                state.data = action.payload
                state.error = null
            })
            .addCase(fetchAdminResumeBuildersAsync.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload || action.error.message
            })

            // Add cases
            .addCase(addAdminResumeBuilderAsync.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(addAdminResumeBuilderAsync.fulfilled, (state, action) => {
                state.loading = false
                state.error = null
            })
            .addCase(addAdminResumeBuilderAsync.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload || action.error.message
            })

            // Update cases
            .addCase(updateAdminResumeBuilderAsync.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(updateAdminResumeBuilderAsync.fulfilled, (state, action) => {
                state.loading = false
                state.error = null
            })
            .addCase(updateAdminResumeBuilderAsync.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload || action.error.message
            })

            // Delete cases
            .addCase(deleteAdminResumeBuilderAsync.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(deleteAdminResumeBuilderAsync.fulfilled, (state, action) => {
                state.loading = false
                state.data = state.data.filter((item) => item.uuid !== action.payload.uuid)
                state.error = null
            })
            .addCase(deleteAdminResumeBuilderAsync.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload || action.error.message
            })
    },
})

export const selectAdminResumeBuilder = (state) => state.adminResumeBuilder.data

export default AdminResumeBuilderSlice.reducer
